export const SELECT_ANNOTATIONS_IN_RECT = 'SELECT_ANNOTATIONS_IN_RECT';

const selectAnnotationsInRect = (state, payload = {}) => {
  const { annotationIds = [], additive = false } = payload;
  const validIds = annotationIds.filter((id) => state.annotations?.[id]);

  if (!additive) {
    if (validIds.length === 0) {
      return state.selectionsIds.length === 0
        ? state
        : { ...state, selectionsIds: [] };
    }

    const sameSelection =
      validIds.length === state.selectionsIds.length &&
      validIds.every((id) => state.selectionsIds.includes(id));

    return sameSelection
      ? state
      : { ...state, selectionsIds: validIds };
  }

  const merged = [...state.selectionsIds];
  validIds.forEach((id) => {
    if (!merged.includes(id)) {
      merged.push(id);
    }
  });

  if (
    merged.length === state.selectionsIds.length &&
    merged.every((id, index) => id === state.selectionsIds[index])
  ) {
    return state;
  }

  return {
    ...state,
    selectionsIds: merged,
  };
};

export default selectAnnotationsInRect;
